import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled(VerticalSpacer)`
  position: relative;
  grid-area: pricing;

  ${mediaQueryUp.tablet} {
    justify-self: end;
  }
`

function AccommodationPackageTilePricingArea(props: PropsWithChildren) {
  return <Container
    {...props}
    gap={12}
  />
}

export default AccommodationPackageTilePricingArea
